import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { holidayCollection } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Holidays{" "}
    <Link className="button" to="/admin/platform/reference/holiday/new">
      New Holiday
    </Link>
  </Fragment>
);

export default function HolidayPage(): ReactNode {
  return (
    <PageLayout title="Reference Platform - Holiday">
      <PaginatedList title={title} collection={holidayCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Date</th>
              <th>Holiday Group</th>
              <th>Holiday Name</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, holidayGroup, holidayDate, holidayName }) => (
              <tr key={id}>
                <td>{holidayDate}</td>
                <td>{holidayGroup}</td>
                <td>{holidayName}</td>
                <td>
                  <Link to={`/admin/platform/reference/holiday/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
